import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import useMakeRequest from '../utils/ApiHelper'
import { ApiConstants } from '../constants/ApiConstants'
import FrontLoader from '../component/layout/FrontLoader'
import { LanguageConstants } from '../constants/LanguageConstants'
import { Config } from '../config/Config'
import { socket } from '../utils/Socket'

function OrderCancel(props: any) {
    const ordercancel = useMakeRequest()
    const [message, setMessage] = useState('')
    const navigate = useNavigate()
    const [error, setError] = useState('')

    const handelSubmit = () => {
        if (!message) {
            return setError('Please enter reason')
        }
        if (message?.length > 250) {
            return setError('Order cancel resoan order limit max 255')
        } else {
            setError('')
            const payload = {
                order_id: props?.data?.uuid,
                reason: message
            }
            ordercancel.makeRequest({ payload, url: ApiConstants?.OrderCancal, toastStatus: true })
        }
    }
    const handleClos = () => {
        props.setCancelShow(false)
        setMessage('')
        setError('')
    }

    useEffect(() => {
        if (ordercancel?.status) {
            const socketpayload = {
                sender_type: "1",
                receiver_id: '1'
            }
            socket.emit('admin_count', socketpayload, async (Response: any) => {
            })
            const url = `${Config?.BASE_URL}/order`
            window.location.href = url

            props.setCancelShow(false)
            setMessage('')
            setError('')
        }
    }, [ordercancel?.status])

    return (
        <>
            {ordercancel?.loading ? <FrontLoader /> : null}
            <div className="modal fade com-modal modal show" id="editQuantityModal" aria-labelledby="editQuantityModalLabel" aria-hidden="false" style={{ display: "block" }} >
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="editQuantityModalLabel">{LanguageConstants?.ORDER_CANCEL_TITAL}</h5>
                            <button type="button" onClick={() => handleClos()} className="btn-close" data-bs-dismiss="modal" aria-label="Close"><i className="icon-close-square" /></button>
                        </div>
                        <div className="modal-body pb-0 text-start">
                            <div className="com-input-wrap mb-3">
                                <label className="form-label">{LanguageConstants?.REASON}</label>
                                <textarea className="form-control" onChange={(e: any) => setMessage(e?.target?.value)} />
                            </div>
                            <p className='text-error-new'>{error}</p>
                        </div>
                        <div className="modal-footer">
                            <button onClick={() => handelSubmit()} className="round-btn m-0 w-100" >{LanguageConstants?.SEND}</button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default OrderCancel